export const productoConstants = {
    MAXIMA_PRIORIDAD:1000,
    REFRESH_CART: 'REFRESH_CART',
    GETALL_SUCCESS_CANDADO: 'GETALL_SUCCESS_CANDADO',
    GETALL_FAILURE_CANDADO: 'GETALL_FAILURE_CANDADO',
};